exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-0da1221b],ol[data-v-0da1221b],li[data-v-0da1221b]{list-style:none;margin:0;padding:0}.emoji[data-v-0da1221b]{width:500px;padding:5px 0;border-radius:5px;background:#fff;-webkit-box-shadow:0 0 5px rgba(0,0,0,0.3);box-shadow:0 0 5px rgba(0,0,0,0.3)}.emoji li[data-v-0da1221b]{display:inline-block;width:30px;padding:5px 10px;cursor:pointer}\n", ""]);

// exports
